import { Component } from "@angular/core";

@Component({
  selector: "bfx-logo-svg",
  templateUrl: "./html/bfx-logo.svg",
  standalone: false,
})
export class BfxLogoSvgComponent {}
